export const authEndpoints = {
  LOGIN: '/auth/login/',
  LOGIN_WITH_2FA: '/auth/login-with-2fa/',
  RESEND_2FA_CODE: '/auth/resend-code/',
  MYINFO: '/users/me/',
  REGISTER: '/auth/register/',
  PASSWORD_RESET: '/auth/password/reset/',
  CHECK_PASSWORD_RESET_LINK: '/auth/password/reset/confirm/:uid/:token/',
  CONFIRM_PASSWORD_RESET: '/auth/password/reset/confirm/:uid/:token/',
  CHANGE_PASSWORD: '/users/change-password/',
  SOCIAL_LOGIN: '/auth/social-login/',
  CHECK_INVITATION: '/users/check-invitation/',
  ACCEPT_INVITATION: '/users/accept-invitation/',
}
